import { Trans } from '@lingui/react/macro'
import {
  AllTagsTab,
  DerivedValuesTab,
  TabButton,
  TabsRowContainer,
  useScatterplotContext,
} from 'features/timeSeries'
import { Calculator, Infinity as InfinityIcon } from 'lucide-react'
import React, { useState } from 'react'
import styled, { css } from 'styled-components'

const TagsTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`

const StyledIcon = css`
  width: 1rem;
  height: 1rem;
`

const StyledInfinity = styled(InfinityIcon)`
  ${StyledIcon}
`
const StyledCalculator = styled(Calculator)`
  ${StyledIcon}
`

export const TagsTab: React.FC = () => {
  const { sensorEntries, selectedSensors } = useScatterplotContext()
  const [selectedTab, setSelectedTab] = useState<'all' | 'derivedValues'>('all')

  return (
    <TagsTabContainer>
      <TabsRowContainer>
        <TabButton
          ghost
          $isSelected={selectedTab === 'all'}
          onClick={() => setSelectedTab('all')}>
          <StyledInfinity />
          <Trans>All</Trans>
        </TabButton>
        <TabButton
          ghost
          $isSelected={selectedTab === 'derivedValues'}
          onClick={() => setSelectedTab('derivedValues')}>
          <StyledCalculator />
          <Trans>Derived Values</Trans>
        </TabButton>
      </TabsRowContainer>
      {selectedTab === 'all' && (
        <AllTagsTab tags={sensorEntries} selectedTags={selectedSensors} />
      )}
      {selectedTab === 'derivedValues' && <DerivedValuesTab />}
    </TagsTabContainer>
  )
}
